import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import { Reference } from 'types/reference';
import Image from 'frontastic/lib/image';
import Slider from 'components/commercetools-ui/atoms/slider';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import {
  desktop,
  hugeDesktop,
  largeDesktop,
  mediumDesktop,
  mobile,
  tablet,
} from 'helpers/utils/screensizes';
import { StaticImageData } from 'next/image';
import { breakpoints } from 'helpers/utils/breakpoints';
import { Tiempos } from 'fonts';
export interface ImageSliderSecondProps {
  data: any;
  title: string;
}
type slideType = {
  image: { url: string | StaticImageData | undefined; title: string | undefined; description: string | undefined };
  call_to_action: { href: string | Reference | undefined };
};
const ImageOnlySecondSlider: React.FC<ImageSliderSecondProps> = ({ data, title }) => {
  const [isTabletSize] = useMediaQuery(tablet);


  const followUsTitle = data?.section_title;
  return (
    <div className="bg-[#EDEDED]">
      <div className="py-48 pl-24 md:py-48 md:pb-100 md:pl-28 lg:pl-48 xl:pb-100 xl:pl-60  xl:pt-60 2xl:pb-154 2xl:pl-80 2xl:pt-80">
        <div className="flex items-center justify-between pr-4">
          <div>
            <Typography className={`pb-32 text-32 font-medium text-[#090909] xl:text-36 2xl:text-[3rem] ${Tiempos.className}`}>
              {followUsTitle}
            </Typography>
          </div>

          {/* Added code (target="_blank" rel="noopener noreferrer) so that Social Media Icons open in new tab. */}
          <div className="mb-15 mr-10 flex justify-center gap-48">
            {/* <MarketButton /> */}
            <ul className="flex flex-row gap-12 self-center 2xl:gap-20">
              {data?.social_media?.social_media_share.map(
                (
                  item: {
                    url: { href: string | Reference | undefined };
                    icon: { url: string | StaticImageData | undefined };
                  },
                  i: string | number | null | undefined,
                ) => (
                  <li key={i} className="w-20 2xl:w-24">
                    <Link link={item?.url?.href} target="_blank" rel="noopener noreferrer">
                      <Image src={item?.icon?.url} className="mb-20" height={24} width={24} />
                    </Link>
                  </li>
                ),
              )}
            </ul>
          </div>
        </div>

        <Slider
          dots={false}
          allowTouchMove
          arrows={isTabletSize}
          innerArrows
          allowArrowsOnTouchDevice
          solidArrows
          nextButtonStyles={{ top: '120%', left: 50 }}
          prevButtonStyles={{ top: '120%', left: 0 }}
          slidesPerView={1.5}
          spaceBetween={16}
          breakpoints={{
            [mobile]: {
              slidesPerView: 2.75,
              spaceBetween: 16,
              ...(breakpoints[mobile] ?? {}),
            },
            [tablet]: {
              slidesPerView: 2.7,
              spaceBetween: 16,
              ...(breakpoints[tablet] ?? {}),
            },
            [mediumDesktop]: {
              slidesPerView: 5.85,
              spaceBetween: 16,
              ...(breakpoints[mediumDesktop] ?? {}),
            },
            [desktop]: {
              slidesPerView: 3.75,
              spaceBetween: 16,
              ...(breakpoints[desktop] ?? {}),
            },
            [largeDesktop]: {
              slidesPerView: 5.5,
              spaceBetween: 16,
              ...(breakpoints[largeDesktop] ?? {}),
            },
            [hugeDesktop]: {
              slidesPerView: 6.5,
              spaceBetween: 16,
              ...(breakpoints[hugeDesktop] ?? {}),
            },
          }}
        >
          {data?.cards?.map((slide: slideType, index: number) => (
            <div className="relative h-[15rem] md:h-[15rem] xl:h-[12rem] 2xl:h-[15rem] " key={index}>
              {slide?.image?.url ? (
                <Image
                  loading="lazy"
                  src={slide?.image?.url}
                  alt={slide?.image?.description}
                  fill
                  style={{ objectFit: 'cover' }}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              ) : (
                <div className="flex-1"></div>
              )}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
export default ImageOnlySecondSlider;
